import { useFindIntegrationDefinitionQuery } from '@jupiterone/jupiter-web-toolkit';
import { useIntegrationInstancesQuery } from 'navbar/src/jupiterAccountSettings/AccountSettings/Notifications/graphql';

const useSlackIntegrationInstances = () => {
  const {
    data: slackIntegrationDefinitionData,
    loading: loadingSlackIntegrationDefinition,
    refetch,
  } = useFindIntegrationDefinitionQuery({
    variables: {
      integrationType: 'slack',
    },
  });
  const slackIntegrationDefinition =
    slackIntegrationDefinitionData?.findIntegrationDefinition?.id;

  const {
    data: integrationInstancesData,
    loading: loadingIntegrationInsances,
  } = useIntegrationInstancesQuery({
    variables: { definitionId: slackIntegrationDefinition || '' },
    skip: !slackIntegrationDefinition,
  });
  const slackIntegrationInstances =
    integrationInstancesData?.integrationInstances?.instances;

  return {
    loading: loadingSlackIntegrationDefinition || loadingIntegrationInsances,
    slackIntegrationInstances,
    refetchSlackIntegrationInstances: refetch,
  };
};

export default useSlackIntegrationInstances;
